import ResourceEditTabBase from "./ResourceEditTabBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import { HasFileBaseMixin } from "@/bryntum-lib/widget/mixins/HasFileBaseMixin.jsx";
import { DEEP_LINK_URL_KEYS } from "@/other/constants/OtherKeys.jsx";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";

export default class ResourceFilesTab extends HasFileBaseMixin(ResourceEditTabBase) {
  static get $name() {
    return "ResourceFilesTab";
  }

  static get type() {
    return "resourcefilestab"
  }

  get recordType() {
    return "resourceId"
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.resourceEditorFilesGridState
  }

  get deepLinkUrlKey() {
    return DEEP_LINK_URL_KEYS.resource;
  }

  get storeKey() {
    return STORE_KEYS.resourceIntegrationsStore;
  }
}

ResourceFilesTab.initClass();
